import { IconButton, InputBase } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DropUpIcon, DropDownIcon } from '../../../../components/Icon';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: '0 1.25rem',
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    display: 'flex',
    height: '3.75rem',
    width: '4.188rem',
    borderRadius: '0.5rem',
    border: '0.0625rem solid #e4e7eb',
    '& .MuiInputBase-input': {
      textAlign: 'center',
      fontFamily: 'NotoSans-Medium',
      fontSize: '1.125rem',
      lineHeight: '1.625rem',
      color: theme.palette.font.main,
      fontWeight: '500',
    },
  },
  btn: {
    width: '1.5rem',
    height: '1.688rem',
    borderRadius: '0',
    margin: '0.5rem auto 1.25rem',
    '&:hover': {
      backgroundColor: theme.palette.font.white,
    },
  },
  icon: {
    fontSize: '0.688rem',
    color: theme.palette.primary.main,
  },
}));

export default function Select({ value, handleAdd, handleReduck, add, reduce, onChange, onBlur, id, readOnly = true }) {
  const classes = useStyles();

  function Color(props) {
    if (props) {
      return '#9b9b9b';
    }
  }

  return (
    <div className={classes.root}>
      <IconButton className={classes.btn} onClick={handleAdd} id={`${id}-add`} disabled={add}>
        <DropUpIcon className={classes.icon} style={{ color: Color(add) }} />
      </IconButton>
      <InputBase
        className={classes.label}
        onChange={onChange}
        id={id}
        value={value}
        readOnly={readOnly}
        onBlur={onBlur}
        inputProps={{
          maxLength: 2,
        }}
      />
      <IconButton className={classes.btn} onClick={handleReduck} id={`${id}-reduce`} disabled={reduce}>
        <DropDownIcon className={classes.icon} style={{ color: Color(reduce) }} />
      </IconButton>
    </div>
  );
}
